module.exports = function (fox) {
	'use strict';
	
	require('./options/options.opt')(fox);

	var require__template = require.context('fox-dynamic-injection!fox-template-loader!./templates', false, /\.tpl$/);
	var template__files = require__template.keys();

	template__files.forEach(function (file) {require__template(file)(fox);});

	var require__stylus = require.context('./stylus', false, /\.styl$/);
	var stylus__files = require__stylus.keys();

	stylus__files.forEach(function (file) {require__stylus(file);});
};



//////////////////
// WEBPACK FOOTER
// ./components/fhg/index.js
// module id = 487
// module chunks = 4